// extracted by mini-css-extract-plugin
export default {"dock":"MobileHomeDock_dock__EQPQi","row":"MobileHomeDock_row__fgHC5","ghost":"MobileHomeDock_ghost__5qm2J","acc":"MobileHomeDock_acc__xy9H1"};